import { combineReducers } from 'redux';
import commonReducer from 'modules/common/reducer';
import generalReducer from 'modules/general/reducer';
import advertisersReducer from 'modules/advertisers/reducer';
import campaignsReducer from 'modules/campaigns/reducer';
import advertsReducer from 'modules/adverts/reducer';
import accountManagementReducer from 'modules/accountManagement/reducer';

export default combineReducers({
  common: commonReducer,
  general: generalReducer,
  advertisers: advertisersReducer,
  campaigns: campaignsReducer,
  adverts: advertsReducer,
  accountManagement: accountManagementReducer,
});
